module.exports = __webpack_public_path__ + "static/media/telegram_bg.03438a58.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/telegram_bg.png
// module id = 41
// module chunks = 0